/* istanbul ignore file */
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

const createPersistentStore = ({
  reducers = {},
  initialState = {},
  middlewares = [],
  enhancers = [],
  options = {},
} = {}) => {
  const finalReducers = combineReducers({
    ...reducers,
  });
  const composeEnhancers = composeWithDevToolsDevelopmentOnly({
    name: 'NikeShop State',
    trace: true,
    traceLimit: 25,
  });
  const enhancer = composeEnhancers(
    applyMiddleware(
      thunk,
      ...middlewares, // should allow adding additional middleware if needed
    ),
    ...enhancers, // should allow adding enhancers like dev tools if needed while implementing
  );

  const store = createStore(finalReducers, initialState, enhancer);
  const persistor = persistStore(store, null, () => {
    store.getState();
  });

  if (options.shouldPurgeWebStorage) {
    persistor.purge();
  }

  return {
    persistor,
    store,
  };
};

export default createPersistentStore;
